"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _default = {
  props: ['ebook', 'failed', 'cardDetails'],
  data: function data() {
    var title = this.ebook.title;
    return {
      title: title
    };
  },
  name: 'ebook-card-skeleton'
};
exports["default"] = _default;